import React from "react";
import { Wrench } from "lucide-react";

/**
 * InImplementationBadge — wine-colored corner badge shown over case thumbs
 * that are flagged `is_in_implementation` in the CMS.
 */
export default function InImplementationBadge({ show, size = "md" }) {
  if (!show) return null;
  const sizes = {
    sm: "top-2 left-2 text-[9px] px-2 py-1",
    md: "top-3 left-3 text-[10px] px-2.5 py-1.5",
    lg: "top-4 left-4 text-xs px-3 py-1.5",
  };
  return (
    <span
      className={`absolute z-10 uppercase tracking-widest font-bold text-white rounded-full flex items-center gap-1.5 shadow-lg ${sizes[size] || sizes.md}`}
      style={{ backgroundColor: "#5B0F1A" /* wine / dark red */ }}
      data-testid="in-implementation-badge"
    >
      <Wrench className={size === "sm" ? "w-2.5 h-2.5" : "w-3 h-3"} />
      Em implementação
    </span>
  );
}

/**
 * ImplementationWrapper — wraps a case card (Link + thumb + text) and, when
 * `active`, disables clicking, shows the badge and applies a subtle washed
 * filter (grayscale + reduced opacity) to the thumb image. When not active,
 * children render untouched.
 */
export function ImplementationWrapper({ active, badgeSize = "sm", children }) {
  if (!active) return children;
  return (
    <div
      className="relative case-in-impl cursor-not-allowed select-none"
      onClickCapture={(e) => { e.preventDefault(); e.stopPropagation(); }}
      data-testid="case-in-implementation"
      aria-disabled="true"
      title="Este case está em implementação."
    >
      <InImplementationBadge show size={badgeSize} />
      {/* Wrapper prevents child navigation clicks. `.case-in-impl img` styling
          is defined in index.css to keep grayscale/opacity in a single place. */}
      <div className="pointer-events-none">
        {children}
      </div>
    </div>
  );
}
